// @ts-ignore
/* eslint-disable */
import { request } from '@umijs/max';

/** Get current user profile GET /api/v1/user/me */
export async function userCurrent(options?: { [key: string]: any }) {
  return request<API.User>('/api/v1/user/me', {
    method: 'GET',
    ...(options || {}),
  });
}

/** Update my profile PUT /api/v1/user/me */
export async function userCurrentUpdate(
  body: API.UserCurrentUpdateRequestDto,
  options?: { [key: string]: any },
) {
  return request<API.User>('/api/v1/user/me', {
    method: 'PUT',
    headers: {
      'Content-Type': 'application/json',
    },
    data: body,
    ...(options || {}),
  });
}

/** Change my password PUT /api/v1/user/me/change-password */
export async function userCurrentChangePassword(
  body: API.UserCurrentChangePasswordRequestDto,
  options?: { [key: string]: any },
) {
  return request<any>('/api/v1/user/me/change-password', {
    method: 'PUT',
    headers: {
      'Content-Type': 'application/json',
    },
    data: body,
    ...(options || {}),
  });
}
